import TableCell from "@tiptap/extension-table-cell";

export const CustomTableCell = TableCell.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      // colwidth is an array of widths
      // (not a number because theoretically cell can have colspan > 1)
      colwidth: {
        default: null,
        parseHTML: (element) => {
          const colwidth = element.getAttribute("colwidth");
          const value = colwidth ? colwidth.split(",").map((width) => parseInt(width, 10)) : null;
          return value;
        },
        renderHTML: (attributes) => {
          return {
            colwidth: attributes.colwidth ? attributes.colwidth.join(",") : null
          };
        }
      }
    };
  }
});
